<template>
    <div>
        <div class="d-flex justify-content-center" style="font-size: 1.1rem; gap:5px; margin-bottom: 2rem; flex-wrap: wrap;">
            <span>Checking in for : </span>
            <span style="font-weight: bold;">{{ checkpoint ? checkpoint.name : '' }}</span>
        </div>
        <div v-if="attendees.length">
            <div  class="d-flex align-items-center mb-4">
                <el-button class="d-flex align-items-center" @click="rescan">
                    <svg style="width: 16px; height:16px;" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                    </svg>
                    <span class="ml-2">Rescan</span>
                </el-button>
    
                <router-link class="ml-2" :to="{ name: 'checkpoints-attendees', params:{ checkpointId: id } }">
                    <el-tooltip content="View Attendees" placement="top">
                        <el-button class="btn btn-secondary" title="More">
                            <fa :icon="['fas', 'users']" />
                        </el-button>
                    </el-tooltip>
                </router-link>
            </div>
    
            <div>
                <div v-if="attendees.length" v-for="(reg, idx) in attendees">
                    <div>
                        <label style="width: max-content;" class="d-flex align-items-center my-4" :for="idx + reg._id" :disabled="reg.checkpoints[id]" :key="idx + reg._id">
                            <span class="hidden">{{ setTicks(idx, reg.checkpoints[id]) }}</span>
                            <div style="position: relative; display: flex; align-items: center;">
                                <label class="checkbox-container m-0">
                                    <input type="checkbox" :disabled="reg.checkpoints[id]" v-model="ticks[idx]" @change="toggleSelectAttendees(reg, ticks[idx])" :id="idx + reg._id">
                                    <span class="checkmark" :disabled="reg.checkpoints[id]">
                                        <svg class="checkmark-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                            <path class="checkmark-path" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                                        </svg>
                                    </span>
                                </label>
                            </div>
                            
                            <p :style="reg.checkpoints[id] ? 'cursor:not-allowed;' : 'cursor: pointer;'" class="m-0 ml-3 d-flex align-items-center">
                                <span :style="reg.checkpoints[id] ? 'font-size: 1.1rem; color:#d3d3d3;':'font-size: 1.1rem;'">{{ reg | registrationName }}</span>
                                <span style="font-weight: lighter; font-size: x-small;" class="ml-1" v-if="reg.checkpoints[id]">(Checked in)</span>
                            </p>

                            <el-button :title="showForms[idx] ? 'Hide Additional Info' : 'Show Additional Info'" v-if="ticks[idx]" @click="toggleShowForm(idx)" size="mini" class="d-flex justify-content-center align-items-center" style="background:none; border:none;">
                                <span class="d-flex justify-content-center align-items-center" style="gap:5px" v-if="showForms[idx]">
                                    <svg style="height:20px; width:20px;" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                    </svg>
                                    Hide                                        
                                </span>
                                <span class="d-flex justify-content-center align-items-center" style="gap:5px" v-else>
                                    <svg style="height:20px; width:20px;" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                    </svg>
                                    More info                                        
                                </span>
                            </el-button>
                        </label>
                    </div>
                    <CheckinDataForm 
                        class="border p-4"
                        v-show="showForms[idx]"
                        v-if="ticks[idx]" 
                        :checkpoint="checkpoint" 
                        :fields="fieldsPerRegistration[reg._id]" 
                        :registration="reg"
                        @change="handleCheckpointFieldDataChange"
                    />
                </div>
            </div>

            <el-button :loading="loading" v-if="attendees.length" style="width: 100%" class="btn btn-primary" @click="checkin">
                {{ selectedAttendees.length ? 'Checkin & Update' : needsSavingFields ? 'Update' : 'Checkin' }}
            </el-button>
        </div>


        <div v-else>
            <div v-if="!processingQr">
                <div class="idinput">
                    <el-input type="text" placeholder="Registration ID or Registration Number" name="" id="" v-model="registrationId" />
                    <el-button class="proceed-btn btn btn-primary" @click="scan" :loading="loading">Proceed</el-button>
                </div>
            </div>
            <p class="my-4" style="font-weight: bold;  text-align: center;">OR</p>
            <div class="badge-scanner">
                <el-button class="scan-badge-btn" :loading="loading" @click="scannerOpen = !scannerOpen">Scan Badge</el-button>
            </div>
            <p class="my-4" style="font-weight: bold;  text-align: center;">OR</p>
            
            <div class="d-flex justify-content-center">
                <router-link class="ml-2" :to="{ name: 'checkpoints-attendees', params:{ checkpointId: id } }">
                    <el-button class="btn btn-secondary" title="More">
                        View Attendees
                    </el-button>
                </router-link>
            </div>
    
            <el-dialog
                v-if="scannerOpen"
                :close-on-click-modal="false"
                :visible.sync="scannerOpen">
                <QrScanner @onDecode="handleDecoded" />
                <p class="d-flex justify-content-center mt-2" style="color: gray;">Switch camera here if needed</p>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import http from "../../http.js";
import { mapState } from 'vuex';
import QrScanner from "../../components/QrScanner.vue"
import Loading from "../Loading.vue";
import CheckinDataForm from "../../components/CheckinDataForm"

export default {
    components: { 
        QrScanner, 
        Loading,
        CheckinDataForm
    },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            registrationId: null,
            attendees: [],
            selectedAttendees: [],
            ticks: [],
            showForms: [],
            loading: false,
            scannerOpen: false,
            processingQr: false,
            checkpoint: null,
            checkpointFields: [],
            fieldDatas: [],
            fieldsPerRegistration: {},
            recordedCheckpointFieldData: [],
            needsSavingFields: false,
            fieldsToShow: [],
            checkpointFieldInfo: {}
        }
    },
    computed: {
        ...mapState(['event', 'checkpoints', "fields"]),
    },
    methods: {
        toggleShowForm(index){
            this.showForms[index] = !this.showForms[index]
            this.showForms = [...this.showForms]
        },
        handleCheckpointFieldDataChange(output){
            this.removeCheckpointFieldData(output.registration._id);
            this.recordedCheckpointFieldData.push(output);
            this.needsSavingFields = true
        },
        removeCheckpointFieldData(regId){
            this.recordedCheckpointFieldData = this.recordedCheckpointFieldData.filter(data => data.registration._id != regId);
        },
        async handleDecoded(data){
            this.registrationId = data;
            this.processingQr = true
            this.scannerOpen = false;
            await this.scan()
        },
        setTicks(idx, val){
            if(this.ticks[idx] == undefined) this.ticks[idx] = val
        },
        toggleSelectAttendees(reg, inc) {
            let elIndex = null
            this.selectedAttendees.forEach((el, index) => {
                if (el == reg._id) elIndex = index;
            })
            if (!inc) {
                this.selectedAttendees.splice(elIndex, 1);
                this.removeCheckpointFieldData(reg._id)
            }
            else this.selectedAttendees.push(reg._id)
        },
        async scan() {
            if(!this.registrationId){
                return this.$notify({
                    message: "Registration id or confirmation number is required",
                    type: "danger"
                });
            }
            this.loading = true
            try {
                const res = await http.post('/api/checkpoints/attendees-by-id', { registrationId: this.registrationId, checkpointId: this.id, eventId: this.event._id })
                this.attendees = res.data.registrations.sort((a,b) => new Date(b.createdAt) - new Date(a.createdAt));
                
                const cf = await http.get(`/api/checkpointfields-data?eventId=${this.$route.params.eventId}&registration=${this.registrationId}`);
                this.fieldDatas = cf.data.data;
        
                this.attendees.forEach(reg =>{
                    const fdata =  this.fieldDatas.find(data => data.registration == reg._id);
                    this.fieldsPerRegistration[reg._id] = []
                    this.fieldsToShow.forEach(el =>{
                        el.value = ""
                        if(fdata && fdata.fields.length){
                            fdata.fields.forEach(f =>{
                                if(f._id == el._id){
                                    el.value = f.value
                                }
                            })
                        }
                        if(!el.value){
                            let registration = el.pullDataFromPrimaryRegistrant ? this.attendees[this.attendees.length - 1] : reg;
                            const val = this.getFieldValueFromRegistration(el._id, registration)
                            if(val) el.value = val;
                        }

                        this.fieldsPerRegistration[reg._id].push({...el})
                    })
                })

                if(res.data.registrations.length == 0){
                    this.$notify({
                        message: "No registrations found",
                        type: "danger"
                    })
                }   
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }
            this.loading = false
            this.processingQr = false;
        },
        getFieldValueFromRegistration(fieldId, registration){
            if(fieldId){
                let regFields = registration.fields;
                let field = regFields.find(el => el._id == fieldId)
                if(field && field.value != undefined) return field.value;
            }
            return null
        },
        rescan() {
            this.selectedAttendees = []
            this.attendees = []
            this.ticks = []
            this.registrationId = ""
        },
        async checkin() {
            if(!this.selectedAttendees.length && this.needsSavingFields){
                return await this.updateFields();
            }
            this.loading = true
            let primaryRegistrant = (this.attendees.find(el => !el.parent))._id;
            try {
                const res = await http.post('/api/checkpoints/checkin', {
                    primaryRegistrant, 
                    attendees: this.selectedAttendees, 
                    checkpointId: this.id, 
                    eventId: this.$route.params.eventId,
                    checkpointFieldData: this.recordedCheckpointFieldData
                })
                this.$notify({ type: 'success', message: res.data.message })
                this.rescan()
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log(e);
            }
            this.loading = false
        },
        async updateFields(){
            try {
                const res = await http.post(`/api/checkpointfields-data/update-fields`, {
                    // checkpointId: this.id, 
                    eventId: this.$route.params.eventId,
                    checkpointFieldData: this.recordedCheckpointFieldData
                })
                this.$notify(res.data.message);
            } catch (error) {
                this.$store.dispatch('handleErrors', error);
            }
        }
    },
    filters: {
        registrationName: (registration) => {
            let name = ''
            const firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
            const lastName = registration.fields.find(field => field.fieldMapping === 'lastName')

            if (firstName) name += firstName.value + ' '
            if (lastName) name += lastName.value

            return name
        },
        formatTimestamp: (date) => moment(date).format('DD MMM YYYY HH:mm')
    },
    async mounted(){
        let params = { filters: { eventId: this.$route.params.eventId } }
        
        if(!this.fields.length) await this.$store.dispatch('getAll', { path: 'fields', params })
        if(!this.checkpoints.length) await this.$store.dispatch('getAll', { path: 'checkpoints', params });

        this.checkpoint = this.checkpoints.find(el => el._id == this.id);

        if(this.$route.query.regNoOrId){
            this.registrationId = this.$route.query.regNoOrId
            this.scan()
        }

        try {
            const res = await http.get(`/api/checkpointfields?eventId=${this.$route.params.eventId}`);
            this.checkpointFields = res.data.fields;
        } catch (error) {
            this.$store.dispatch('handleErrors', error);
        }

        this.checkpointFieldInfo = {}
        this.checkpoint.fieldsForCheckinAndAttendeesPage.forEach((el, order) =>{
            this.checkpointFieldInfo[el._id] = {
                pullDataFromPrimaryRegistrant: el.pullDataFromPrimaryRegistrant,
                order
            };
        })

        this.fields.forEach(el =>{
            if(Object.keys(this.checkpointFieldInfo).includes(el._id)){
                el.pullDataFromPrimaryRegistrant = this.checkpointFieldInfo[el._id].pullDataFromPrimaryRegistrant
                el.order = this.checkpointFieldInfo[el._id].order
                this.fieldsToShow.push(el)
            }
        });
        
        this.checkpointFields.forEach(el =>{
            if(Object.keys(this.checkpointFieldInfo).includes(el._id)){
                el.pullDataFromPrimaryRegistrant = this.checkpointFieldInfo[el._id].pullDataFromPrimaryRegistrant
                el.order = this.checkpointFieldInfo[el._id].order
                this.fieldsToShow.push(el)
            }
        });

        this.fieldsToShow.sort((a,b) => a.order - b.order);

        if(this.checkpoint && !this.checkpoint.checkinEnabled) return this.$router.push(`/forbidden/${this.event._id}`)
    }
}


</script>

<style scoped>

/* Hide the default checkbox */
.checkbox-container input {
    display: none;
}
.checkbox-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Create a custom checkbox */
.checkbox-container .checkmark {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: #ffffff;
    position: relative;
    cursor: pointer;
    border: 0.5px solid rgb(156, 156, 156);
}

/* Hide the SVG checkmark by default */
.checkbox-container .checkmark-svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    stroke-width: 5;
    stroke: #ffffff;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 71;
    stroke-dashoffset: 71;
    transition: all 0.3s ease-out;
    opacity: 0;
}

/* Show the SVG checkmark when the checkbox is checked */
.checkbox-container input:checked ~ .checkmark .checkmark-svg {
    stroke-dashoffset: 0;
    opacity: 1;
}
.checkbox-container input:checked ~ .checkmark {
    background: #409EFF;
}
.checkbox-container input:checked ~ .checkmark[disabled] {
    background: #d3d3d3;
    cursor: not-allowed;
}

.idinput{
    display: flex;
    align-items: center;
    gap: 5px;
    max-width: 500px;
    margin: 0 auto;
}

.badge-scanner{
    max-width: 500px;
    margin: 0 auto;
}

.scan-badge-btn{
    width: 100%;
    min-width: max-content;
}

@media screen and (max-width: 500px) {
    .idinput{
        flex-direction: column;
    }
    .proceed-btn{
        width: 100%;
    }
}

</style>